import { useTranslation } from 'react-i18next';

interface IAddress {
  isPrimary?: boolean;
  title: string;
  address1?: string;
  address2?: string;
  address3?: string;
  postcode?: string;
  city?: string;
  country?: string;
}

export function AddressSummary({
  isPrimary = false,
  title,
  address1,
  address2 = '',
  address3 = '',
  postcode,
  city,
  country,
}: IAddress) {
  const { t } = useTranslation();
  const hasAddress: boolean = !!(address1 || address2 || postcode || city || country);

  if (!hasAddress && !isPrimary) return <></>;

  return (
    <>
      {hasAddress ? (
        <div className="flex flex-col gap-2 typo-body-regular-paragraph font-bold">
          <p className="text-tertiary">{title}</p>
          <div>
            <p>{address1 || t('pages.dashboard.createUser.form.noAddress')}</p>
            <p>{address2}</p>
            <p>{address3}</p>
            <p>
              {postcode || t('pages.dashboard.createUser.form.noPostcode')}{' '}
              {city || t('pages.dashboard.createUser.form.noCity')}
            </p>
            <p>{country ? t(`shared.countries.${country}`) : t('pages.dashboard.createUser.form.noCountry')}</p>
          </div>
        </div>
      ) : (
        '-'
      )}
    </>
  );
}
